import type { DurationPreset, DurationUnit } from "./DurationPicker.types";

export const DURATION_PRESETS: DurationPreset[] = [
  { id: "1h", label: "1 h", amount: 1, unit: "hours" },
  { id: "24h", label: "24 h", amount: 24, unit: "hours" },
  { id: "7d", label: "7 days", amount: 7, unit: "days" },
  { id: "30d", label: "30 days", amount: 30, unit: "days" },
  { id: "3mo", label: "3 months", amount: 3, unit: "months" },
  { id: "1y", label: "1 year", amount: 1, unit: "years" },
  { id: "never", label: "Never", amount: null, unit: null },
];

export const DURATION_UNITS: DurationUnit[] = ["minutes", "hours", "days", "months", "years"];

/** now + amount unit, as ISO. */
export const addDuration = (now: Date, amount: number, unit: DurationUnit): string => {
  const d = new Date(now.getTime());
  if (unit === "minutes") d.setMinutes(d.getMinutes() + amount);
  else if (unit === "hours") d.setHours(d.getHours() + amount);
  else if (unit === "days") d.setDate(d.getDate() + amount);
  else if (unit === "months") d.setMonth(d.getMonth() + amount);
  else d.setFullYear(d.getFullYear() + amount);
  return d.toISOString();
};

export const formatUntil = (iso: string): string =>
  new Date(iso).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
